import { render } from "./WrapperView.vue?vue&type=template&id=63d9e56a&scoped=true"
import script from "./WrapperView.vue?vue&type=script&lang=js"
export * from "./WrapperView.vue?vue&type=script&lang=js"

import "./WrapperView.vue?vue&type=style&index=0&id=63d9e56a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63d9e56a"

export default script